<template>
  <div class="form">
    <mt-field
        v-model.trim="auth.mobile"
        type="number"
        :label="$t('login.mobile')"
        class="form-group"
    ></mt-field>

    <mt-field
        v-model.trim="auth.password"
        type="password"
        :label="$t('login.password')"
        class="form-group"
    ></mt-field>

    <mt-field
        v-model.trim="auth.captcha"
        class="captcha-field form-group"
        :label="$t('login.captcha')"
        @keydown.tab="() => this.$refs.loginButton.focus()"
    >
      <img :src="captchaImageUrl" class="captcha" @click="refreshCaptcha">
    </mt-field>

    <div style="display: flex; justify-content: center;">
      <mt-button class="mt-10 ds-button-large" size="large" type="primary" @click="signIn" ref="loginButton">
        {{ $t('login.login') }}
      </mt-button>
    </div>

  </div>
</template>

<script>
import { login } from '@src/api/memberLogin'
import { Indicator, Toast } from 'mint-ui'
import { mapMutations } from 'vuex'
import { checkInviter } from '@/api/memberInviter'
import { getAddressList } from '@src/api/memberAddress'

export default {
  name: 'LoginByMobile',
  components: {
  },
  data () {
    return {
      captchaImageUrl: '',
      currentIndex: 0,
      auth: {
        mobile: '',
        password: '',
        captcha: undefined
      }
    }
  },
  created: function () {
    this.refreshCaptcha()
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin',
      saveSellerAuthInfo: 'sellerLogin',
      memberPoint: 'memberPoint'
    }),
    checkInviter,
    refreshCaptcha () {
      this.captchaImageUrl = process.env.VUE_APP_API_HOST + '/Seccode/makecode?r=' + Math.random()
    },
    signIn () {
      Indicator.open()
      login(this.auth.mobile, this.auth.password, this.auth.captcha).then(async response => {
          Indicator.close()
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          if (response.result.seller_info) {
            this.saveSellerAuthInfo({ token: response.result.seller_token, info: response.result.seller_info })
          }
         await getAddressList().then(res => {
             if (res.code !== 10000) {
               console.log('Member Login Get Address Failed');
             } else {
               let defaultAddress = res.result.address_list.filter(address => address.address_is_default === "1").shift()
               if (defaultAddress) {
                this.memberPoint({
                  point: {
                    address: defaultAddress.address_detail,
                    lat: defaultAddress.address_latitude,
                    lng: defaultAddress.address_longitude
                  }
                })
               }
             }
          })

          this.checkInviter().catch((err) => {
              console.error('Check inviter error', err)
          })
          this.$emit('getLoginState', true)
        },
        error => {
          Indicator.close()
          Toast(error.message)
          this.$emit('getLoginState', false)
        }
      )
    }
  }
}
</script>

<style lang='scss' scoped>

.captcha-field {
  height: 2.5rem;
}

.captcha {
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  border: 2px solid gray;
  border-radius: 5px;
  width: 6rem;
}
.form {
  padding: 0 1rem;
}
.form-group:first-child {
  border: none;
}
.form-group {
  border: none;
  height: 2.5rem;
  background: transparent;
  display: flex;
  position: relative;
  margin-bottom: 10px;
  ::v-deep .mint-cell-title{
    font-size: 0.8rem;
    width: 100px;
  }
  ::v-deep .mint-cell-value {
    border-radius: 5px;
    height: 1.6rem;
    background: white;
    .mint-field-core {
      font-size: 0.8rem;
    }
  }
  ::v-deep .mint-field-state{
    margin-right: 5px;
    margin-left: 0px;
  }
  ::v-deep .form-error {
    padding-left: 0rem;
    padding-bottom: 0rem;
    background-color: transparent;
    position: absolute;
    bottom: -0.5rem;
    left: 6rem;
  }
}
.mint-button--primary {
  background: #DD2C35 !important;
  width: 90%;
  border-radius: 28px;
  box-shadow: 0px 1px 0px 0px black;
}
.captcha-field {
  ::v-deep .mint-cell {
    width: 100%;
  }
}
</style>
